<template>
    <div>
        <Teleport to="#modals">
            <Transition name="modal-fade" appear>
                <SearchModal 
                    v-if="modal.show.value" 
                    @close="modal.hideModal"
                    :rootId="parsedRootID"
                />
            </Transition>
        </Teleport>
        <button class="svg-button svg-button--search-modal search-modal-button" title="Open Search" type="button" @click="openConfirm">
            <svg height="24" width="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
            </svg>
        </button>
    </div>
</template>

<script setup>

import { useModal } from '../composables/useModal.ts';
import { markRaw, toRefs } from 'vue';
import SearchModal from '../components/SearchModal.vue';

const modal = useModal();

const props = defineProps({
    rootId: {
        type: Number,
        required: true,
    }
});

const { rootId } = toRefs(props);

const parsedRootID = rootId.value;

const openConfirm = () => {
  modal.component.value = markRaw(SearchModal);
  modal.showModal();
  //parsedRootID = rootId.value;
};


</script>